import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './Menu.css';
import { configureAnchors } from 'react-scrollable-anchor';
import { Logo } from '../Logos/Logos';

configureAnchors({offset: -60, scrollDuration: 600})


class Menu extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
    <div className="menu-container">
      <div className="logo">
        <div>
          <Logo />
        </div>
        <div>
          <h2>Werkap</h2>
          <p>TECH HEROES</p>
        </div>
      </div>
      <nav className='menu'>
        <a href='#' onClick = {() => this.props.hideProject()}>Home</a>
        <a href='#Projects' onClick = {() => this.props.hideProject()}>Work</a>
        <a href='#Services' onClick = {() => this.props.hideProject()}>Services</a>
        <a href='#Team' onClick = {() => this.props.hideProject()}>Team</a>
      </nav>
    </div> 
    );
  }
}

export default Menu;


// WEBPACK FOOTER //
// ./src/Menu/Menu.js